import DataQuery from "@ternary/api-lib/analytics/api/DataQuery";
import { RawData } from "@ternary/api-lib/analytics/types";
import AnalyticsApiClient from "../AnalyticsApiClient";

// NOTE: This results in a limit of 600k rows.
const MAX_ROWS = 600_000;

export async function getPaginatedResults(params: {
  client: AnalyticsApiClient;
  nextPageToken?: string;
  previousResults: RawData[];
  query: DataQuery;
  tenantID: string;
}) {
  const { client, nextPageToken, previousResults, query, tenantID } = params;

  query.next_page_token = nextPageToken;

  // NOTE: This is a temporary adjustment to limit the number of rows,
  // the same limit used in the CSV export.
  query.limit = MAX_ROWS;

  const results = await client.loadData(tenantID, query);

  const currentDataset = [...previousResults, ...results.response];

  if (!results.next_page_token) {
    return currentDataset;
  }

  return await getPaginatedResults({
    client,
    nextPageToken: results.next_page_token,
    previousResults: currentDataset,
    query,
    tenantID,
  });
}
